import { useEffect, useState } from "react";
import style from "./Home.module.css";

function Home() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkScreenSize();

    // Add event listener with throttling for better performance
    let timeoutId;
    const handleResize = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(checkScreenSize, 100);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className={style.container}>
      <div className={style.background_element}></div>

      <div className={style.card_wrapper}>
        <div className={style.card} id="home">
          <div className={style.content}>
            <div className={style.text_content}>
              <h1 className={style.title}>
                Web Developer{" "}
                <i className="fa-regular fa-hand-peace" aria-hidden="true"></i>
              </h1>
              <p className={style.bio}>
                Hi, I'm Pramod, a Passionate and Enthusiastic Web Developer.
                <br className={style.desktop_break} />
                Based in Kathmandu, Nepal
                <i className="fa-solid fa-house" aria-hidden="true"></i>.
              </p>

              <div className={style.cta_container}>
                <a href="#contact" className={style.cta_button}>
                  Get in Touch
                </a>
                <a href="#projects" className={style.cta_secondary}>
                  View Projects
                </a>
              </div>

              <div className={style.social_links}>
                <a
                  href="https://www.linkedin.com/in/pramod-mahto-4309aa222/"
                  aria-label="LinkedIn"
                  className={style.social_link}
                >
                  <i className="fa-brands fa-linkedin"></i>
                </a>
                <a
                  href="https://github.com/pramod-k-mahto"
                  aria-label="GitHub"
                  className={style.social_link}
                >
                  <i className="fab fa-github"></i>
                </a>
                <a
                  href="mailto:contact@pramodmahto.com"
                  aria-label="Email"
                  className={style.social_link}
                >
                  <i className="fa-solid fa-envelope"></i>
                </a>
              </div>

              <div className={style.tech_stack}>
                <div className={style.stack_header}>
                  <strong>Tech Stack</strong>
                </div>
                <div className={style.stack_icons}>
                  <span className={style.tech_icon} title="HTML5">
                    <i className="fa-brands fa-html5"></i>
                  </span>
                  <span className={style.tech_icon} title="CSS3">
                    <i className="fa-brands fa-css3"></i>
                  </span>
                  <span className={style.tech_icon} title="JavaScript">
                    <i className="fa-brands fa-js"></i>
                  </span>
                  <span className={style.tech_icon} title="React">
                    <i className="fa-brands fa-react"></i>
                  </span>
                  <span className={style.tech_icon} title="Java">
                    <i className="fa-brands fa-java"></i>
                  </span>
                  <span className={style.tech_icon} title="Python">
                    <i className="fa-brands fa-python"></i>
                  </span>
                </div>
              </div>
            </div>

            <div className={style.profile_container}>
              <div className={style.profile_wrapper}>
                <div className={style.profile_image}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
